import { Schema } from 'yup'

type NullableSchema<T> = Schema<T | null | undefined>

export function makeFieldNullish<T>(schema: Schema<T>): NullableSchema<T> {
  return schema.optional().nullable()
}
